/** 管理路由 */
import Layout from '@/views/layout/indexLayout'

const Router = {
	path: '/index',
	component: Layout,
	redirect: '/index/index',
	name: 'index',
	hidden: true,
	meta: {
		requiresAuth: true,
		title: '系统首页',
		index: 0,
		type: 'index'
	},
	children: [
		{
			path: 'index', 
			component: () => import('@/views/index/index'),
			meta: {
				requiresAuth: true,
				title: '系统首页',
				icon: 'workbench',
				index: 1,
				type: 'index',
				subType: 'index'
			}
		}
  ]
}

export default Router